import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const GreenColorButton = styled(Button)(() => ({
  textTransform: "capitalize",
  color: "#ffffff",
  fontFamily: "PoppinsMedium",
  outline:"none",
  border: 0,
  backgroundColor: "#0FBE7C",
  borderRadius:"8px",
  "&:focus": {
    outline: "none",
  },
  "&:hover": {
    backgroundColor: "#0FBE7C",
  },
  "&.Mui-disabled": {
    backgroundColor: "#0FBE7C",
    color: "#FFFFFF",
    opacity:0.5,
    cursor: "not-allowed",
  },
}));

export const TransparentColorButton = styled(Button)(() => ({
  textTransform: "capitalize",
  color: "#ffffff",
  fontFamily: "PoppinsMedium",
  outline:"none",
  border: 0,
  backgroundColor: "transparent",
  "&:focus": {
    outline: "none",
  },
  "&:hover": {
    backgroundColor: "transparent",
    color:"#0FBE7C",
  },
  "&.Mui-disabled": {
    backgroundColor: "transparent",
    color: "#FFFFFF",
    cursor: "not-allowed",
  },
}));

export const PrimeGrayColorButton = styled(Button)(() => ({
  textTransform: "capitalize",
  color: "#ffffff",
  fontFamily: "PoppinsMedium",
  outline:"none",
  border: 0,
  backgroundColor: "#666666",
  borderRadius:"8px",
  "&:focus": {
    outline: "none",
  },
  "&:hover": {
    backgroundColor: "#666666",
  },
  "&.Mui-disabled": {
    backgroundColor: "#666666",
    color: "#FFFFFF",
    cursor: "not-allowed",
  },
}));

export const PrimeGreenBorderColorButton = styled(Button)(() => ({
  textTransform: "capitalize",
  color: "#0FBE7C",
  fontFamily: "PoppinsMedium",
  backgroundColor: "transparent",
  border:"1px solid #0FBE7C",
  borderRadius:"8px",
  "&:focus": {
    outline: "none",
  },
}));

export const PrimeGrayBorderColorButton = styled(Button)(() => ({
  textTransform: "capitalize",
  color: "#666666",
  fontFamily: "PoppinsMedium",
  backgroundColor: "transparent",
  border:"1px solid #A7ABA9",
  borderRadius:"8px",
  "&:focus": {
    outline: "none",
  },
}));

export const PrimeDarkButton = styled(Button)(() => ({
  textTransform: "capitalize",
  color: "#ffffff",
  fontFamily: "PoppinsMedium",
  outline:"none",
  border:"1px solid #28282A",
  backgroundColor: "#28282A",
  borderRadius:"8px",
  "&:focus": {
    outline: "none",
  },
  "&:hover": {
    backgroundColor: "#28282A",
  },
  "&.Mui-disabled": {
    backgroundColor: "#28282A",
    color: "#FFFFFF",
    cursor: "not-allowed",
  },
}));

export const PrimeDarkBorderColorButton = styled(Button)(() => ({
  textTransform: "capitalize",
  color: "#28282A",
  fontFamily: "PoppinsMedium",
  backgroundColor: "transparent",
  border:"1px solid #28282A",
  borderRadius:"8px",
  "&:focus": {
    outline: "none",
  },
}));

export const DarkGreenColorButton = styled(Button)(() => ({
  textTransform: "capitalize",
  color: "#ffffff",
  fontFamily: "PoppinsMedium",
  outline:"none",
  border: 0,
  backgroundColor: "#12A59B",
  borderRadius:"8px",
  "&:focus": {
    outline: "none",
  },
  "&:hover": {
    backgroundColor: "#12A59B",
  },
  "&.Mui-disabled": {
    backgroundColor: "#12A59B",
    color: "#FFFFFF",
    cursor: "not-allowed",
  },
}));

export const RedColorButton = styled(Button)(() => ({
  textTransform: "capitalize",
  color: "#ffffff",
  fontFamily: "PoppinsMedium",
  outline:"none",
  border: 0,
  backgroundColor: "#E62A4A",
  borderRadius:"8px",
  "&:focus": {
    outline: "none",
  },
  "&:hover": {
    backgroundColor: "#E62A4A",
  },
  "&.Mui-disabled": {
    backgroundColor: "#E62A4A",
    color: "#FFFFFF",
    cursor: "not-allowed",
  },
}));

export const BlueColorButton = styled(Button)(() => ({
  textTransform: "capitalize",
  color: "#ffffff",
  fontFamily: "PoppinsMedium",
  outline:"none",
  border: 0,
  backgroundColor: "#1565C0",
  "&:focus": {
    outline: "none",
  },
  "&:hover": {
    backgroundColor: "#1565C0",
  },
  "&.Mui-disabled": {
    backgroundColor: "#1565C0",
    color: "#FFFFFF",
    cursor: "not-allowed",
  },
}));

export const RedColorBorderButton = styled(Button)(() => ({
  textTransform: "capitalize",
  color: "#E62A4A",
  fontFamily: "PoppinsMedium",
  backgroundColor: "transparent",
  border:"1px solid #E62A4A",
  borderRadius:"8px",
  "&:focus": {
    outline: "none",
  },
}));

export const OrangeColorButton = styled(Button)(() => ({
  textTransform: "capitalize",
  color: "#ffffff",
  fontFamily: "PoppinsMedium",
  outline:"none",
  border: 0,
  backgroundColor: "#FBAB4E",
  "&:focus": {
    outline: "none",
  },
  "&:hover": {
    backgroundColor: "#FBAB4E",
  },
  "&.Mui-disabled": {
    backgroundColor: "#FBAB4E",
    color: "#FFFFFF",
    cursor: "not-allowed",
  },
}));


export const StatusStyle = (e) =>{
  if(e?.toLowerCase() == "active" || e?.toLowerCase() == "finalised" || e?.toLowerCase()=="accepted" ||e?.toLowerCase() == "phy-approved"|| e?.toLowerCase()=="approved"||e?.toLowerCase()=="verified"|| e?.toLowerCase()=="passed" ||e?.toLowerCase()=="completed"){
    return "text-capitalize Bg-Active poppinsMedium borderRadius4 w-100 px-3 Text-Prime-Green py-1 text-center";
  }
  if(e?.toLowerCase() == "in active" || e?.toLowerCase() == "rejected" || e?.toLowerCase() =="failed"|| e?.toLowerCase()=="medical-rejected"||e?.toLowerCase() =="phy-rejected"||e?.toLowerCase() =="cbt-rejected" ){
    return "text-capitalize Bg-InActive poppinsMedium borderRadius4 w-100 px-3 Text-Prime-Red py-1 text-center"; //red
  }
  if( e?.toLowerCase() == "under review"||e?.toLowerCase()=="waiting for call letter" ||e?.toLowerCase()=="call letter received" || e?.toLowerCase()=="not completed"){ 
    return "text-capitalize Bg-Pending poppinsMedium borderRadius4 w-100 px-3 py-1 Text-Pending text-center"; //orange
  }
  if(e?.toLowerCase() == "medical test"||e?.toLowerCase() == "medical approved" || e?.toLowerCase()=="submitted" ){
    return "text-capitalize Bg-MedicalTest poppinsMedium borderRadius4 w-100 px-3 py-1 Text-MedicalTest text-center";
  }
  if(  e?.toLowerCase() == "online test" ){
    return "text-capitalize Bg-OnlineTest poppinsMedium borderRadius4 w-100 px-3 py-1 Text-Prime-Blue text-center"; //blue
  }
  if( e?.toLowerCase() == "open" ){
    return "text-capitalize Bg-Pending poppinsMedium borderRadius4 px-3 py-1 Text-Pending text-center"; //orange
  }
  if(e?.toLowerCase() == "closed"||e?.toLowerCase() =="cbt-completed" ||e?.toLowerCase() =="finalized"){
    return "text-capitalize Bg-Light-Green poppinsMedium borderRadius4 px-3 py-1 Text-DK-Green1 text-center"; //green
  }
  if( e?.toLowerCase() == "upcoming"){
    return "text-capitalize Bg-Light-Blue poppinsMedium borderRadius4 px-3 py-1 Text-Sky-Blue text-center"; //blue
  }
  if(  e?.toLowerCase() == "paused"){
    return "text-capitalize Bg-MedicalTest poppinsMedium borderRadius4 px-3 py-1 Text-MedicalTest text-center"; //pink
  }
  if(e?.toLowerCase() == "pending" ){
    return "text-capitalize Bg-pendings poppinsMedium borderRadius4 px-3 py-1 Text-Prime-Gray text-center"; //pink
  }
}